import React from 'react';
import {
  Dialog,
  DialogContent,
} from '@/components/ui/dialog';
import { Badge } from '@/components/ui/badge';
import CallsDetailOverviewWidget from '@/components/widgets/call-overview/CallsDetailOverviewWidget';
import { CallsOverviewTableColumns } from '@/enums/call-overvew-column';
import { usePreventSpaceKey } from '@/hooks/usePreventSpaceKey';

interface AgentQueueBadgeProps {
  agentName?: string;
  queueName?: string;
}

export const AgentQueueBadge: React.FC<AgentQueueBadgeProps> = ({ agentName, queueName }) => {
  if (!agentName && !queueName) {
    return null;
  }

  return (
    <Badge variant="outline" className="ml-2 font-normal text-xs text-inherit">
      {agentName} - {queueName}
    </Badge>
  );
};

interface TotalHandledCallsModalProps {
  isOpen: boolean;
  onClose: () => void;
  dateParams?: {
    startDate: string;
    endDate: string;
    previousStartDate: string;
    previousEndDate: string;
    queueMicrosoftIds?: string[] | null;
    agentMicrosoftIds?: string[] | null;
    groupIds?: number[] | null;
  };
  callIds?: string[];
  agentName?: string;
  queueName?: string;
}

export const TotalHandledCallsModal: React.FC<TotalHandledCallsModalProps> = ({
  isOpen,
  onClose,
  dateParams,
  callIds = [],
  agentName,
  queueName,
}) => {
  // Prevent space key from triggering default behavior
  usePreventSpaceKey(isOpen);

  return (
    <Dialog open={isOpen} onOpenChange={onClose}>
      <DialogContent
        className="sm:max-w-[95vw] max-h-[90vh] overflow-auto p-0"
        closeClassName="z-50"
        onOpenAutoFocus={(e) => e.preventDefault()}
      >
        {dateParams ? (
          <CallsDetailOverviewWidget
            callDirectionTypes={null}
            dateParams={dateParams}
            limit={10}
            callMicrosoftIds={callIds}
            hiddenColumns={[
              CallsOverviewTableColumns.CALL_QUEUE,
              CallsOverviewTableColumns.CALL_STATUS,
              CallsOverviewTableColumns.RECIPIENT,
              CallsOverviewTableColumns.VOICEMAIL_DURATION
            ]}
            exportHiddenColumns={[
              CallsOverviewTableColumns.CALL_STATUS,
              CallsOverviewTableColumns.RECIPIENT
            ]}
            exportButtonClassName="mr-10"
            hideTooltips={true}
            agentName={agentName}
            queueName={queueName}
          // csvOnlyColumns={[]}
          />
        ) : (
          <div className="text-sm text-muted-foreground py-4">
            No date parameters provided
          </div>
        )}
      </DialogContent>
    </Dialog>
  );
};

